// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrap[data-v-5f5e6e40] { width: 'inherit';\n}\n", ""]);
// Exports
module.exports = exports;
